import React from 'react'

const OPDRefund = () => {
  return (
    <div>OPD Refund</div>
  )
}

export default OPDRefund